import { patientSortTypeAtom } from '../../types/Patients.types';
import { BrowserAnalyticsClientFactory } from '@orthly/analytics/dist/browser';
import { useToolbarSelectProps } from '@orthly/dentin';
import { LabsGqlPatientSortType } from '@orthly/graphql-schema';
import { SimpleSelect } from '@orthly/ui';
import { FlossPalette, styled } from '@orthly/ui-primitives';
import { useAtom } from 'jotai';
import React from 'react';

const SortContainer = styled('div')({
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column',
    borderLeft: `1px solid ${FlossPalette.DARK_TAN}`,
});

const PatientsToolbarSortOptionsToLabelMap: Record<LabsGqlPatientSortType, string> = {
    [LabsGqlPatientSortType.CreatedAt]: 'Most Recently Created',
    [LabsGqlPatientSortType.FirstNameAscending]: 'First Name (A-Z)',
    [LabsGqlPatientSortType.FirstNameDescending]: 'First Name (Z-A)',
    [LabsGqlPatientSortType.LastNameAscending]: 'Last Name (A-Z)',
    [LabsGqlPatientSortType.LastNameDescending]: 'Last Name (Z-A)',
};

export const PatientsToolbarSort: React.VFC = () => {
    const selectProps = useToolbarSelectProps();

    const [sortBy, setSortBy] = useAtom(patientSortTypeAtom);

    return (
        <SortContainer>
            <SimpleSelect
                {...selectProps}
                options={Object.entries(PatientsToolbarSortOptionsToLabelMap).map(([value, label]) => ({
                    value: `${value}`,
                    label,
                }))}
                onChange={value => {
                    if (value) {
                        BrowserAnalyticsClientFactory.Instance?.track(
                            'Practice - Patient Page - Sort By Option Selected',
                            {
                                sortBy: value,
                            },
                        );
                        setSortBy(value as any);
                    }
                }}
                label={'Sort by'}
                value={`${sortBy}`}
                SelectProps={{ ...selectProps.SelectProps, displayEmpty: false, variant: 'standard' }}
                variant={'filled'}
                backgroundColor={FlossPalette.WHITE}
                style={{ borderRadius: 0, border: 'none', boxShadow: 'none' }}
            />
        </SortContainer>
    );
};
